import { Box } from "@mui/material";
import React, { Suspense, useContext } from "react";
import MainContext from "../../context/mainContext";
import { RouterConfig } from "../App/RouterConfig";
import Header from "../Header";
import MainLoading from "../MainLoading";
import styles from "./Layout.module.scss";

const Layout: React.FC = () => {
  const { loadingCurrentUser, banner, bannerLink } = useContext(MainContext);

  return loadingCurrentUser ? (
    <MainLoading />
  ) : (
    <Suspense fallback={<MainLoading />}>
      <Box className={styles.layout}>
        <Header />
        <Box component="div" className={styles.pageBox}>
          {banner &&
            (bannerLink ? (
              <a href={bannerLink} target="_blank" rel="noreferrer">
                <img
                  className={styles.pageBanner}
                  src={require(`../../assets/images/${banner}`)}
                  alt="banner"
                />
              </a>
            ) : (
              <img
                className={styles.pageBanner}
                src={require(`../../assets/images/${banner}`)}
                alt="banner"
              />
            ))}
          <RouterConfig />
        </Box>
      </Box>
    </Suspense>
  );
};

export default Layout;
